export enum EDeviceStatus {
    ALL = 'ALL',
    ONLINE = 'Online',
    OFFLINE = 'Offline',
    GPS_NOT_CONNECTED = 'GPS Not Connected',
    MOVING = 'Moving',
    STOPPED = 'Stopped',
    IDLE = 'Idle',
    STOPPED_REPORTING = 'Stopped Reporting',
    NEVER_CONNECTED = 'Never Connected',

    ALARM_ARMED = 'Armed',
    ALARM_DISARMED = 'Disarmed',
}

export enum EDeviceSignal {
    EXCELLENT = 'Excellent',
    GOOD = 'Good',
    POOR = 'Poor',
    BAD = 'Bad',
    NONE = 'None',
}

export enum ETripStatus {
    OPEN = 'Open',
    CLOSED = 'Closed',
}

export enum ELosantDeviceClass {
    GATEWAY = 'Gateway',
    FLOATING = 'Floating',
    DEVICE = 'Device',
}

export function getDeviceStatusFromString(value: string): EDeviceStatus {
    switch (value.toLowerCase().trim()) {
        case 'armed':
            return EDeviceStatus.ALARM_ARMED;
        case 'disarmed':
            return EDeviceStatus.ALARM_DISARMED;
        case 'online':
            return EDeviceStatus.ONLINE;
        case 'offline':
            return EDeviceStatus.OFFLINE;
        case 'gps not connected':
            return EDeviceStatus.GPS_NOT_CONNECTED;
        case 'moving':
            return EDeviceStatus.MOVING;
        case 'stopped':
            return EDeviceStatus.STOPPED;
        case 'idle':
            return EDeviceStatus.IDLE;
        case 'stopped reporting':
            return EDeviceStatus.STOPPED_REPORTING;
        case 'never connected':
        default:
            return EDeviceStatus.NEVER_CONNECTED;
    }
}
